import { render, staticRenderFns } from "./competition.vue?vue&type=template&id=4462c75a&scoped=true&"
import script from "./competition.vue?vue&type=script&lang=js&"
export * from "./competition.vue?vue&type=script&lang=js&"
import style0 from "./competition.vue?vue&type=style&index=0&id=4462c75a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4462c75a",
  null
  
)

export default component.exports